/**
 * Determines the appropriate display text for content based on availability
 *
 * @param text - The transcript or text content
 * @param contentUrl - URL to the content (audio, image, etc.)
 * @param audioFileUrl - Legacy audio file URL for backward compatibility
 * @returns The display text: actual content, "Transcript not available", or "No content available"
 */
export function getContentDisplayText(
  text: string | undefined | null,
  contentUrl?: string | undefined | null,
  audioFileUrl?: string | undefined | null
): string {
  // If we have text content, return it
  if (text) {
    return text;
  }

  // If we have a content URL or audio file URL but no text, transcript is not available
  if (contentUrl || audioFileUrl) {
    return 'Transcript not available';
  }

  // No content at all
  return 'No content available';
}
